import truck1 from "../../assets/truck1.webp";
import truck2 from "../../assets/truck2.webp";
import truck3 from "../../assets/truck3.webp";
import truck4 from "../../assets/truck4.webp";
import truck5 from "../../assets/truck5.webp";
import truck6 from "../../assets/truck6.webp";
import truck7 from "../../assets/truck7.webp";
import truck8 from "../../assets/truck8.webp";
import truck9 from "../../assets/truck9.webp";

export const industries = [
  {
    title: "Logistics",
    description:
      "Optimize logistics operations with our tailored fleet management solutions.",
    image: truck1,
  },
  {
    title: "Construction",
    description:
      "Boost project oversight and equipment efficiency in the construction industry.",
    image: truck2,
  },
  {
    title: "Agriculture",
    description:
      "Increase productivity in agriculture with smart tracking and monitoring solutions.",
    image: truck3,
  },
  {
    title: "Education",
    description:
      "Ensure safety and efficiency in educational transportation.",
    image: truck4,
  },
  {
    title: "Waste Management",
    description:
      "Optimize waste collection routes and enhance overall efficiency.",
    image: truck5,
  },
  {
    title: "Forklifts",
    description:
      "Improve operational efficiency and safety with real-time tracking and monitoring.",
    image: truck6,
  },
  {
    title: "Tankers",
    description:
      "Ensure secure transportation and monitor tank openings and closures.",
    image: truck7,
  },
  {
    title: "Dumpers",
    description:
      "Enhance safety and stability with advanced monitoring solutions for dumper trucks.",
    image: truck8,
  },
  {
    title: "Smart Genset",
    description:
      "Maximize generator reliability and performance with smart telematics.",
    image: truck9,
  },
];